import { Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import intl from 'localization/components'
import { StatusBadge } from 'components/ui/badge/status-badge'

// ENG2-2411: active / inactive badge for a row's API token. "Active" means the
// token is neither revoked nor expired (computed by RisikaAPI). Rows without a
// token, or served by an API that predates the field, show a dash.

interface TokenStatusViewProps {
  props: {
    apiUserData?: { active?: boolean } | null
  }
}

const TokenStatusView = ({ props }: TokenStatusViewProps) => {
  const { formatMessage } = useIntl()
  const active = props?.apiUserData?.active

  if (active === undefined || active === null) {
    return <Typography sx={{ fontSize: 14 }}>-</Typography>
  }

  return (
    <StatusBadge
      status={active ? 'active' : 'inactive'}
      label={formatMessage({
        id: intl.userManagement(active ? 'token-active' : 'token-inactive'),
      })}
    />
  )
}

export default TokenStatusView
